<template>
  <div class="code-editor" ref="el"></div>
</template>

<script>
import CodeMirror from "codemirror";
// css
import "./codemirror.css";
import "codemirror/addon/lint/lint.css";
import "codemirror/theme/idea.css";
import "codemirror/theme/material-palenight.css";

require("script-loader!jsonlint");
// modes
import "codemirror/mode/javascript/javascript";
import "codemirror/addon/lint/lint";
import "codemirror/addon/lint/json-lint";
import "codemirror/mode/css/css";
import "codemirror/mode/htmlmixed/htmlmixed";
import "codemirror/addon/edit/matchbrackets.js";
import "codemirror/addon/wrap/hardwrap.js";

// search
import "codemirror/addon/scroll/annotatescrollbar.js";
import "codemirror/addon/search/matchesonscrollbar.js";
import "codemirror/addon/search/match-highlighter.js";
import "codemirror/addon/search/jump-to-line.js";
import "codemirror/addon/dialog/dialog.js";
import "codemirror/addon/dialog/dialog.css";
import "codemirror/addon/search/searchcursor.js";
import "codemirror/addon/search/search.js";

// fold
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/addon/fold/foldcode";
import "codemirror/addon/fold/foldgutter";
import "codemirror/addon/fold/brace-fold";
import "codemirror/addon/fold/comment-fold";

export default {
  name: "CodeMirror",
  /* eslint-disable vue/require-prop-types */
  /*props: ['value'],*/

  props: {
    value: {
      type: String,
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mirror: false
    };
  },
  watch: {
    value(value) {
      const editorValue = this.mirror.getValue();
      if (value !== editorValue) {
        this.mirror.setValue(this.value || "");
      }
    }
  },
  mounted() {
    this.mirror = CodeMirror(this.$refs.el, {
      lineNumbers: true,
      mode: "application/json",
      gutters: ["CodeMirror-lint-markers"],
      theme: "idea",
      tabSize: 2,
      autoCloseBrackets: true,
      autoCloseTags: true,
      lint: true,
      matchBrackets: true,

      foldGutter: true,
      lineWrapping: true,
      gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter", "CodeMirror-lint-markers"],

      extraKeys: {
        "Ctrl--": cm => CodeMirror.commands.foldAll(cm),
        "Ctrl-=": cm => CodeMirror.commands.unfoldAll(cm),
        "Ctrl-S": cm => this.save(cm)
      },
      readOnly: this.readOnly
    });
    this.mirror.setValue(this.value || "");
    this.mirror.on("change", () => {
      this.$emit("change", this.mirror.getValue());
    });
  },
  methods: {
    getValue() {
      return this.mirror.getValue();
    },
    save() {
      this.$emit("save", this.mirror.getValue());
    }
  }
};
</script>

<style lang="scss" scoped>
.code-editor {
  height: 100% !important;
  position: relative;
  overflow: hidden;
}
</style>
